import { AllUsers } from '@/features/user/components/allUsers/AllUsers';

export function UserPage() {
  return <AllUsers />;
}
